/**
 * Badge medallions in the Owlbert sketch style. One SVG per badge type in /public/badges,
 * generated by scripts/design/badge-art.cjs from scripts/design/badges.json. The shape says the
 * category, the frame colour says the rarity, the motif is the badge's icon.
 */
export function badgeArtUrl(type: string, earned = true) { return earned ? `/badges/${type}.svg` : "/badges/locked.svg"; }

export function BadgeArt({ type, name, earned = true, size = 64, className = "" }: { type: string; name?: string; earned?: boolean; size?: number; className?: string }) {
  return (
    <img
      src={badgeArtUrl(type, earned)}
      alt={earned ? (name ? `${name} badge` : "Badge") : "Locked badge"}
      width={size}
      height={size}
      loading="lazy"
      draggable={false}
      className={`inline-block select-none pointer-events-none ${earned ? "" : "opacity-60"} ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
